export default "__VITE_PUBLIC_ASSET__44e49567__"